export default "__VITE_ASSET__CrThVwZA__"